import { connect } from 'react-redux'
import {
  login,
  validateCompany,
  getCurrentUser,
  frameSuccessLogin,
  frameSuccessRelogin,
  validateCompanyKsa,
} from 'redux/authUser/actionCreators'
import VisitorLanguag from './VisitorLanguag'

import Login from './Login'
import './style.css'

const mapStateToProps = ({ auth }) => ({
  fetching: auth.fetching,
  company: auth.company,
  login_attempt: auth.policies,
})

export default connect(mapStateToProps, {
  login,
  getCurrentUser,
  validateCompany,
  frameSuccessLogin,
  frameSuccessRelogin,
  validateCompanyKsa,
})(VisitorLanguag(Login))
